module.exports = __webpack_public_path__ + "img/wordpress-seeklogo.com 2.bf653303.svg";